export enum CountdownAppearance {
    "GALLERY_VIEW",
    "PRODUCT_VIEW",
    "ORDER_VIEW",
    "GALLERY_SM_VIEW"
}